import React, { PureComponent } from 'react';
import { Button, ButtonGroup } from '@material-ui/core'

class TabsForTransitLayer extends PureComponent {
    render() {
        const {

            transitDataFilterChoice,
            setChoiceForTransitLayer,

        } = this.props;

        return (
            <div className="center-area-under-layerSwitch">
                <ButtonGroup variant="contained" color="secondary">
                    <Button
                        className={transitDataFilterChoice === 0 ? 'selected' : ''}
                        onClick={() => setChoiceForTransitLayer(0)}
                    >
                        missed
                    </Button>
                    <Button
                        className={transitDataFilterChoice === 1 ? 'selected' : ''}
                        onClick={() => setChoiceForTransitLayer(1)}
                    >
                        served
                    </Button>
                    <Button
                        className={transitDataFilterChoice === 2 ? 'selected' : ''}
                        onClick={() => setChoiceForTransitLayer(2)}
                    >
                        all units
                    </Button>
                </ButtonGroup>
            </div>
        )
    }
}

export default TabsForTransitLayer